import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ActionType,
  Actions,
  Store,
  ofActionDispatched,
  ofActionSuccessful,
} from '@ngxs/store';
import { MonoTypeOperatorFunction, filter, takeUntil, tap } from 'rxjs';

@Injectable()
export class EventHelper {
  readonly #actions$: Actions;
  readonly #store: Store;
  readonly #destroyRef = inject(DestroyRef);

  constructor(store: Store, actions$: Actions) {
    this.#store = store;
    this.#actions$ = actions$;
  }

  connectEvents(
    on: ActionType,
    trigger: ActionType | object,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    when: any = ofActionSuccessful,
    instanciate = true
  ): void {
    this.#actions$
      .pipe(takeUntilDestroyed(this.#destroyRef), when(on))
      .subscribe(() => {
        setTimeout(() => {
          let action;
          if (instanciate) {
            const ctor = trigger as { new (): ActionType };
            action = new ctor();
          } else {
            action = trigger;
          }

          this.#store.dispatch(action);
        }, 0);
      });
  }

  makeCancelOperator<A extends ActionType>(
    action: A,
    condition: (action: A) => boolean,
    callback?: (action: A) => void
  ): MonoTypeOperatorFunction<unknown> {
    // Disconnect the subscription if it is requested to load
    // other data while the loading process is not finished.
    const notifier = this.#actions$.pipe(
      ofActionDispatched(action),
      // Filters loading orders with the same id that is being
      // processed and does not cancel them.
      filter((action: A) => condition(action)),
      tap((act: A) => {
        if (callback) {
          callback(act);
        }
      })
    );
    return takeUntil(notifier);
  }
}
